import React, { useState } from 'react'
import GradesComponent from "./gradesComponent";
import { Box, Tabs, Tab } from "@mui/material";
import {IContentAreaProps} from "../../../types";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  // style: React.CSSProperties;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
  );
}


function App({ parentSize }: IContentAreaProps) {
  const [value, setValue] = useState(1);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
      <div style={{ ...parentSize, overflow: "hidden" }}>
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
          <Tabs value={value} onChange={handleChange} centered>
            <Tab label="Alloys" disabled={true} />
            <Tab label="Lime" />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0} >
          <GradesComponent parentSize={{ width: parentSize.width - 16, height: parentSize.height - 148 }} />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1} >
          <GradesComponent parentSize={{ width: parentSize.width - 16, height: parentSize.height - 148 }} />
        </CustomTabPanel>
      </div>
  )
}

export default App
